var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('NavMenu',{staticClass:"nav_menu"}),_c('NoticeTable',{staticClass:"notice_table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }